import { render, staticRenderFns } from "./ScoreObj.vue?vue&type=template&id=ba8e7d24&scoped=true"
import script from "./ScoreObj.vue?vue&type=script&lang=js"
export * from "./ScoreObj.vue?vue&type=script&lang=js"
import style0 from "./ScoreObj.vue?vue&type=style&index=0&id=ba8e7d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8e7d24",
  null
  
)

export default component.exports